import { DSBestListComparisonTableState } from 'shared-definitions/types'

export function isEqualBestListFilter(
  state: DSBestListComparisonTableState,
  defaultState: DSBestListComparisonTableState
): boolean {
  for (const key in state) {
    const kVal = state[key],
      defaultKVal = defaultState[key]

    if (typeof kVal === 'object' && typeof defaultKVal === 'object') {
      if (kVal === null || defaultKVal === null) {
        if (kVal !== defaultKVal) {
          return false
        }
        continue
      }

      if (kVal.max !== defaultKVal.max || kVal.min !== defaultKVal.min) {
        return false
      }
    }

    if (kVal !== defaultKVal) {
      return false
    }
  }

  return true
}
